// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_sb__TlZBl {
  background-color: var(--color-primary-4);
  color: var(--color-white);
  box-sizing: border-box;
  padding: 4rem 2rem;
  height: 100vh;
  cursor: pointer;
  width: 20vw;
  transition: all 850ms;
  position: Fixed;
  z-index: 10;
}
@media only screen and (max-width: 62.5em) {
  .Sidebar_sb__TlZBl {
    width: 40vw;
  }
}
@media only screen and (max-width: 37.5em) {
  .Sidebar_sb__TlZBl {
    width: 60vw;
  }
}
.Sidebar_sb_navItem__VBvVz {
  display: flex;
  justify-content: space-between;
}
.Sidebar_sb_title__3jop2 {
  display: flex;
  align-items: center;
  padding: 0 2rem;
  gap: 1rem;
  margin-bottom: 2rem;
}
.Sidebar_sb_icon__c4X3N {
  font-size: 3rem;
}
.Sidebar_sb_logo__FgM4x {
  height: 3rem;
}
.Sidebar_sb_nav__0CzGT {
  box-sizing: border-box;
  height: 50vh;
  padding-right: 1rem;
  overflow-y: auto;
}
@media only screen and (max-width: 81.25em) {
  .Sidebar_sb_nav__0CzGT {
    height: 50vh;
  }
}
@media only screen and (max-width: 62.5em) {
  .Sidebar_sb_nav__0CzGT {
    height: 66vh;
  }
}
@media only screen and (max-width: 56.25em) {
  .Sidebar_sb_nav__0CzGT {
    height: 60vh;
  }
}
@media only screen and (max-width: 37.5em) {
  .Sidebar_sb_nav__0CzGT {
    height: 57vh;
  }
}
@media only screen and (max-width: 25em) {
  .Sidebar_sb_nav__0CzGT {
    height: 52vh;
  }
}
.Sidebar_sb_nav__0CzGT::-webkit-scrollbar {
  width: 0.5rem;
  background-color: var(--color-white);
}
.Sidebar_sb_nav__0CzGT::-webkit-scrollbar:active, .Sidebar_sb_nav__0CzGT::-webkit-scrollbar:hover {
  width: 1rem;
}
.Sidebar_sb_nav__0CzGT::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
}
.Sidebar_sb_nav_2__vWNIH {
  box-sizing: border-box;
  padding-right: 1rem;
  height: 80vh;
  overflow-y: auto;
}
.Sidebar_sb_nav_2__vWNIH::-webkit-scrollbar {
  width: 0.5rem;
  background-color: var(--color-white);
}
.Sidebar_sb_nav_2__vWNIH::-webkit-scrollbar:active, .Sidebar_sb_nav_2__vWNIH::-webkit-scrollbar:hover {
  width: 1rem;
}
.Sidebar_sb_nav_2__vWNIH::-webkit-scrollbar-thumb {
  background-color: var(--color-primary-3);
}
.Sidebar_sb_nav_ul__SIy2E {
  display: flex;
  flex-direction: column;
  align-items: space-evenly;
  margin: 0;
  padding: 0;
  gap: 1rem;
  list-style: none;
}
.Sidebar_sb_nav_ul__SIy2E > * {
  padding: 0.75rem 2rem;
  list-style: none;
}
.Sidebar_sb_nav_item__OJG2Q {
  font-size: var(--default-font-small);
  font-weight: 700;
}
.Sidebar_sb_nav_item_active__KMYr\\+, .Sidebar_sb_nav_item__OJG2Q:hover {
  background-color: var(--color-white);
  color: var(--color-dark);
  border-radius: 0.75rem;
}
.Sidebar_sb_nav_link__jm0mm {
  display: flex;
  align-items: center;
  gap: 1rem;
}
@media only screen and (max-width: 62.5em) {
  .Sidebar_sb_nav_link__jm0mm {
    justify-content: flex-start;
    gap: 1rem;
  }
}
.Sidebar_sb_nav_link_icon__j1GwF {
  font-size: 2rem;
}
.Sidebar_sb_nav_link_arr__diHFd {
  font-size: 2rem;
}
.Sidebar_sb_nav_link_arr_1__gCcDj {
  font-size: 2rem;
  transform: rotateX(180deg);
}
.Sidebar_sb_nav_link_group__XgctE {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Sidebar_sb__min__dOiqO {
  background-color: var(--color-primary-4);
  color: var(--color-white);
  box-sizing: border-box;
  padding: 4rem 2rem;
  height: 100vh;
  width: 12vw;
  cursor: pointer;
  transition: all 850ms;
  position: Fixed;
}
.Sidebar_sb__min_title__VhtZy {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}
.Sidebar_sb__min_icon__7pCd3 {
  font-size: 3rem;
}
.Sidebar_sb__min_logo__wh3JY {
  display: none;
}
.Sidebar_sb__min_nav_ul__tRFHU {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 0;
  gap: 1rem;
  list-style: none;
}
.Sidebar_sb__min_nav_ul__tRFHU > * {
  padding: 0.75rem 2rem;
  list-style: none;
}
.Sidebar_sb__min_nav_link_text__MUID3 {
  display: none;
}

.Sidebar_subNav_ul__rerUN {
  display: flex;
  flex-direction: column;
  align-items: space-evenly;
  margin: 1rem 0;
  padding: 0;
  gap: 0.5rem;
  list-style: none;
}
.Sidebar_subNav_ul__rerUN > * {
  padding: 0.75rem 1.3rem;
  list-style: none;
}
.Sidebar_subNav_li_active__DMzIy, .Sidebar_subNav_li__sLroE:hover {
  background-color: var(--color-dark);
  color: var(--color-white);
  border-radius: 0.75rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/AppHome/Sidebar.module.scss"],"names":[],"mappings":"AAEA;EACC,wCAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;AADD;AAIC;EAbD;IAcE,WAAA;EADA;AACF;AAGC;EAjBD;IAkBE,WAAA;EAAA;AACF;AAEC;EACC,aAAA;EACA,8BAAA;AAAF;AAGC;EACC,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AADF;AAIC;EACC,eAAA;AAFF;AAKC;EACC,YAAA;AAHF;AAMC;EACC,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AAJF;AAME;EAND;IAOE,YAAA;EAHD;AACF;AAKE;EAVD;IAWE,YAAA;EAFD;AACF;AAIE;EAdD;IAeE,YAAA;EADD;AACF;AAGE;EAlBD;IAmBE,YAAA;EAAD;AACF;AAEE;EAtBD;IAuBE,YAAA;EACD;AACF;AACE;EACC,aAAA;EACA,oCAAA;AACH;AACG;EAEC,WAAA;AAAJ;AAIE;EACC,mCAAA;AAFH;AAKE;EACC,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AAHH;AAKG;EACC,aAAA;EACA,oCAAA;AAHJ;AAKI;EAEC,WAAA;AAJL;AAQG;EACC,wCAAA;AANJ;AAUE;EACC,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AARH;AAUG;EACC,qBAAA;EACA,gBAAA;AARJ;AAYE;EACC,oCAAA;EACA,gBAAA;AAVH;AAYG;EAEC,oCAAA;EACA,wBAAA;EACA,sBAAA;AAXJ;AAeE;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAbH;AAeG;EALD;IAME,2BAAA;IACA,SAAA;EAZF;AACF;AAcG;EACC,eAAA;AAZJ;AAeG;EACC,eAAA;AAbJ;AAeI;EACC,eAAA;EACA,0BAAA;AAbL;AAiBG;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;AAfJ;;AAqBA;EACC,wCAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AAlBD;AAoBC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AAlBF;AAqBC;EACC,eAAA;AAnBF;AAsBC;EACC,aAAA;AApBF;AAwBE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AAtBH;AAwBG;EACC,qBAAA;EACA,gBAAA;AAtBJ;AA2BG;EACC,aAAA;AAzBJ;;AAiCC;EACC,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AA9BF;AAiCE;EACC,uBAAA;EACA,gBAAA;AA/BH;AAsCE;EAEC,mCAAA;EACA,yBAAA;EACA,sBAAA;AArCH","sourcesContent":["@import '../variables/breakpoints';\n\n.sb {\n\tbackground-color: var(--color-primary-4);\n\tcolor: var(--color-white);\n\tbox-sizing: border-box;\n\tpadding: 4rem 2rem;\n\theight: 100vh;\n\tcursor: pointer;\n\twidth: 20vw;\n\ttransition: all 850ms;\n\tposition: Fixed;\n\tz-index: 10;\n\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\twidth: 40vw;\n\t}\n\n\t@media only screen and (max-width: $bp-600) {\n\t\twidth: 60vw;\n\t}\n\n\t&_navItem {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n\n\t&_title {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: 0 2rem;\n\t\tgap: 1rem;\n\t\tmargin-bottom: 2rem;\n\t}\n\n\t&_icon {\n\t\tfont-size: 3rem;\n\t}\n\n\t&_logo {\n\t\theight: 3rem;\n\t}\n\n\t&_nav {\n\t\tbox-sizing: border-box;\n\t\theight: 50vh;\n\t\tpadding-right: 1rem;\n\t\toverflow-y: auto;\n\n\t\t@media only screen and (max-width: $bp-1300) {\n\t\t\theight: 50vh;\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\theight: 66vh;\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-900) {\n\t\t\theight: 60vh;\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\theight: 57vh;\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-400) {\n\t\t\theight: 52vh;\n\t\t}\n\n\t\t&::-webkit-scrollbar {\n\t\t\twidth: .5rem;\n\t\t\tbackground-color: var(--color-white);\n\n\t\t\t&:active,\n\t\t\t&:hover {\n\t\t\t\twidth: 1rem;\n\t\t\t}\n\t\t}\n\n\t\t&::-webkit-scrollbar-thumb {\n\t\t\tbackground-color: var(--color-grey);\n\t\t}\n\n\t\t&_2 {\n\t\t\tbox-sizing: border-box;\n\t\t\tpadding-right: 1rem;\n\t\t\theight: 80vh;\n\t\t\toverflow-y: auto;\n\n\t\t\t&::-webkit-scrollbar {\n\t\t\t\twidth: .5rem;\n\t\t\t\tbackground-color: var(--color-white);\n\n\t\t\t\t&:active,\n\t\t\t\t&:hover {\n\t\t\t\t\twidth: 1rem;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&::-webkit-scrollbar-thumb {\n\t\t\t\tbackground-color: var(--color-primary-3);\n\t\t\t}\n\t\t}\n\n\t\t&_ul {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: space-evenly;\n\t\t\tmargin: 0;\n\t\t\tpadding: 0;\n\t\t\tgap: 1rem;\n\t\t\tlist-style: none;\n\n\t\t\t&>* {\n\t\t\t\tpadding: 0.75rem 2rem;\n\t\t\t\tlist-style: none;\n\t\t\t}\n\t\t}\n\n\t\t&_item {\n\t\t\tfont-size: var(--default-font-small);\n\t\t\tfont-weight: 700;\n\n\t\t\t&_active,\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-white);\n\t\t\t\tcolor: var(--color-dark);\n\t\t\t\tborder-radius: 0.75rem;\n\t\t\t}\n\t\t}\n\n\t\t&_link {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 1rem;\n\n\t\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\t\tjustify-content: flex-start;\n\t\t\t\tgap: 1rem;\n\t\t\t}\n\n\t\t\t&_icon {\n\t\t\t\tfont-size: 2rem;\n\t\t\t}\n\n\t\t\t&_arr {\n\t\t\t\tfont-size: 2rem;\n\n\t\t\t\t&_1 {\n\t\t\t\t\tfont-size: 2rem;\n\t\t\t\t\ttransform: rotateX(180deg);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&_group {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.sb__min {\n\tbackground-color: var(--color-primary-4);\n\tcolor: var(--color-white);\n\tbox-sizing: border-box;\n\tpadding: 4rem 2rem;\n\theight: 100vh;\n\twidth: 12vw;\n\tcursor: pointer;\n\ttransition: all 850ms;\n\tposition: Fixed;\n\n\t&_title {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tmargin-bottom: 2rem;\n\t}\n\n\t&_icon {\n\t\tfont-size: 3rem;\n\t}\n\n\t&_logo {\n\t\tdisplay: none;\n\t}\n\n\t&_nav {\n\t\t&_ul {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t\tmargin: 0;\n\t\t\tpadding: 0;\n\t\t\tgap: 1rem;\n\t\t\tlist-style: none;\n\n\t\t\t&>* {\n\t\t\t\tpadding: 0.75rem 2rem;\n\t\t\t\tlist-style: none;\n\t\t\t}\n\t\t}\n\n\t\t&_link {\n\t\t\t&_text {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.subNav {\n\n\t&_ul {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: space-evenly;\n\t\tmargin: 1rem 0;\n\t\tpadding: 0;\n\t\tgap: .5rem;\n\t\tlist-style: none;\n\n\n\t\t&>* {\n\t\t\tpadding: 0.75rem 1.3rem;\n\t\t\tlist-style: none;\n\t\t}\n\n\t}\n\n\t&_li {\n\n\t\t&_active,\n\t\t&:hover {\n\t\t\tbackground-color: var(--color-dark);\n\t\t\tcolor: var(--color-white);\n\t\t\tborder-radius: 0.75rem;\n\t\t}\n\t}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sb": `Sidebar_sb__TlZBl`,
	"sb_navItem": `Sidebar_sb_navItem__VBvVz`,
	"sb_title": `Sidebar_sb_title__3jop2`,
	"sb_icon": `Sidebar_sb_icon__c4X3N`,
	"sb_logo": `Sidebar_sb_logo__FgM4x`,
	"sb_nav": `Sidebar_sb_nav__0CzGT`,
	"sb_nav_2": `Sidebar_sb_nav_2__vWNIH`,
	"sb_nav_ul": `Sidebar_sb_nav_ul__SIy2E`,
	"sb_nav_item": `Sidebar_sb_nav_item__OJG2Q`,
	"sb_nav_item_active": `Sidebar_sb_nav_item_active__KMYr+`,
	"sb_nav_link": `Sidebar_sb_nav_link__jm0mm`,
	"sb_nav_link_icon": `Sidebar_sb_nav_link_icon__j1GwF`,
	"sb_nav_link_arr": `Sidebar_sb_nav_link_arr__diHFd`,
	"sb_nav_link_arr_1": `Sidebar_sb_nav_link_arr_1__gCcDj`,
	"sb_nav_link_group": `Sidebar_sb_nav_link_group__XgctE`,
	"sb__min": `Sidebar_sb__min__dOiqO`,
	"sb__min_title": `Sidebar_sb__min_title__VhtZy`,
	"sb__min_icon": `Sidebar_sb__min_icon__7pCd3`,
	"sb__min_logo": `Sidebar_sb__min_logo__wh3JY`,
	"sb__min_nav_ul": `Sidebar_sb__min_nav_ul__tRFHU`,
	"sb__min_nav_link_text": `Sidebar_sb__min_nav_link_text__MUID3`,
	"subNav_ul": `Sidebar_subNav_ul__rerUN`,
	"subNav_li_active": `Sidebar_subNav_li_active__DMzIy`,
	"subNav_li": `Sidebar_subNav_li__sLroE`
};
export default ___CSS_LOADER_EXPORT___;
